import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type LegalKey = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<LegalKey>(null);
  return <footer className="bg-ivory py-[32px] md:py-[48px] px-6 border-t border-border" data-id="element-137">
      <div className="max-w-[860px] mx-auto text-center" data-id="element-138">
        <div className="font-mono text-[11px] leading-[1.9] text-text-secondary flex flex-col items-center gap-2" data-id="element-139">
          <p data-id="element-140">
            EL AZÚCAR SILENCIOSO · por Roderic Guillen · GoDeskCore · Heartbeat
          </p>
          <p data-id="element-141">
            <button type="button" onClick={() => setOpenModal('privacy')} className="hover:underline underline-offset-[3px] transition-colors hover:text-text-primary" data-id="element-142">
              Privacidad
            </button>{' '}
            ·{' '}
            <button type="button" onClick={() => setOpenModal('terms')} className="hover:underline underline-offset-[3px] transition-colors hover:text-text-primary" data-id="element-143">
              Términos
            </button>
          </p>
          <p data-id="element-144">© 2025 GoDeskCore · Todos los derechos reservados</p>
          <p className="text-[10px] text-text-muted leading-[1.6] mt-6 max-w-[600px]" data-id="element-145">
            Este producto es informativo y educativo. No constituye consejo
            médico ni reemplaza la consulta con un profesional de salud.
          </p>
        </div>
      </div>

      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-146">
        <div className="font-sans text-[14px] leading-[1.8] space-y-4" data-id="element-147">
          <p data-id="element-148">
            En GoDeskCore valoramos y respetamos tu privacidad. Esta política
            explica cómo tratamos la información relacionada con la compra y
            descarga de "El Azúcar Silencioso".
          </p>
          <div data-id="element-149">
            <h3 className="font-serif font-bold text-[16px] text-text-primary mb-1" data-id="element-150">
              Información que recopilamos
            </h3>
            <p data-id="element-151">
              Únicamente recopilamos los datos necesarios para procesar tu
              compra y entregarte el producto digital, como tu nombre y correo
              electrónico. Los pagos se procesan a través de plataformas seguras
              y nunca almacenamos los datos de tu tarjeta.
            </p>
          </div>
          <div data-id="element-152">
            <h3 className="font-serif font-bold text-[16px] text-text-primary mb-1" data-id="element-153">
              Uso de la información
            </h3>
            <p data-id="element-154">
              Usamos tus datos exclusivamente para entregarte el libro y los
              bonos, gestionar tu garantía y enviarte información relacionada
              con tu compra. No vendemos ni compartimos tu información con
              terceros con fines comerciales.
            </p>
          </div>
          <div data-id="element-155">
            <h3 className="font-serif font-bold text-[16px] text-text-primary mb-1" data-id="element-156">
              Seguridad
            </h3>
            <p data-id="element-157">
              Implementamos medidas razonables para proteger tu información. La
              transmisión de datos se realiza mediante conexiones cifradas
              (SSL).
            </p>
          </div>
          <div data-id="element-158">
            <h3 className="font-serif font-bold text-[16px] text-text-primary mb-1" data-id="element-159">
              Tus derechos
            </h3>
            <p data-id="element-160">
              Puedes solicitar el acceso, la corrección o la eliminación de tus
              datos personales en cualquier momento conforme a la legislación
              aplicable.
            </p>
          </div>
        </div>
      </LegalModal>

      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-161">
        <div className="font-sans text-[14px] leading-[1.8] space-y-4" data-id="element-162">
          <p data-id="element-163">
            Al adquirir "El Azúcar Silencioso" aceptas los siguientes términos y
            condiciones. Te recomendamos leerlos con atención.
          </p>
          <div data-id="element-164">
            <h3 className="font-serif font-bold text-[16px] text-text-primary mb-1" data-id="element-165">
              Naturaleza del producto
            </h3>
            <p data-id="element-166">
              Este es un producto digital (PDF) de carácter informativo y
              educativo. No constituye consejo médico, diagnóstico ni
              tratamiento, y no reemplaza la consulta con un profesional de la
              salud.
            </p>
          </div>
          <div data-id="element-167">
            <h3 className="font-serif font-bold text-[16px] text-text-primary mb-1" data-id="element-168">
              Entrega
            </h3>
            <p data-id="element-169">
              El acceso al libro y a los bonos se entrega de forma inmediata
              tras confirmarse el pago. Al tratarse de un producto digital, la
              descarga está disponible al instante.
            </p>
          </div>
          <div data-id="element-170">
            <h3 className="font-serif font-bold text-[16px] text-text-primary mb-1" data-id="element-171">
              Garantía y reembolsos
            </h3>
            <p data-id="element-172">
              Ofrecemos una garantía de 7 días. Si dentro de ese periodo
              consideras que el producto no cumplió lo prometido, puedes
              solicitar el reembolso completo sin necesidad de explicaciones.
            </p>
          </div>
          <div data-id="element-173">
            <h3 className="font-serif font-bold text-[16px] text-text-primary mb-1" data-id="element-174">
              Propiedad intelectual
            </h3>
            <p data-id="element-175">
              Todo el contenido está protegido por derechos de autor. Tu compra
              es para uso personal; no está permitido reproducir, distribuir ni
              revender el material sin autorización.
            </p>
          </div>
          <div data-id="element-176">
            <h3 className="font-serif font-bold text-[16px] text-text-primary mb-1" data-id="element-177">
              Limitación de responsabilidad
            </h3>
            <p data-id="element-178">
              GoDeskCore no se hace responsable de las decisiones tomadas en
              base a la información del libro. Cada lector es responsable de
              consultar a su médico antes de realizar cambios en su salud.
            </p>
          </div>
        </div>
      </LegalModal>
    </footer>;
}